import { customScrollMinimal, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const ScrollContainer = styled.div`
  height: 100%;
  overflow: auto;
  ${customScrollMinimal};
`;

export const MenuBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: var(--surface-default);
`;

export const AssetsCounter = styled.div`
  color: var(--text-soft);
  ${typographyV2.bodyXs};
`;
